/* eslint-disable import/no-anonymous-default-export */
export default {
  DEPOSITS: (query) =>
    `https://content.progressplay.net/api23/api/InfoContent?${query}`,
};
